"use client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { ReactNode } from "react";
import theme from "~/components/theme/theme";
import BorderGlowFilterClient from "./BorderGlowFilterClient";

import InitColorSchemeScript from "@mui/material/InitColorSchemeScript";

interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <>
      <InitColorSchemeScript attribute="class" defaultMode="light" />
      <MuiThemeProvider theme={theme} defaultMode="light">
        <CssBaseline />
        <BorderGlowFilterClient />
        {children}
      </MuiThemeProvider>
    </>
  );
}
